// 👇️ ts-nocheck ignores all ts errors in the file

// @ts-nocheck
import React, { useEffect, useState } from 'react'
import PageTitle from '../../components/Typography/PageTitle'
import { Button } from '@windmill/react-ui'
import { ArrowLeftIcon } from '@mui/x-date-pickers'
import { Navigate, useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useForm } from 'react-hook-form'
import { useAlert } from 'react-alert'
import { useAuth } from '../../context/Auth'
import { create } from '../../lib/fetch/partners'
import { uploadPartnerImage } from '../../lib/fetch/uploads'
import UploadImage from '../../components/UploadImage'

function NuovoPartner({ currentPermissions, location }) {
  const canWrite = currentPermissions.can('write', 'partners')
  const intl = useIntl()
  const history = useNavigate()
  const [auth = {}] = useAuth()
  //const { showLoading, hideLoading } = useLoading();
  const { token } = auth
  const [image, setImage] = useState(null)
  const [imageFile, setImageFile] = useState(null)
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors }
  } = useForm()
  const alert = useAlert()

  async function onSubmit(values) {
    const { name, status } = values

    //showLoading();
    const { error, data } = await create({
      data: {
        name,
        status: status === 'true'
      },
      token
    })

    //hideLoading();
    if (error) {
      alert.error(intl.formatMessage({ id: 'COMMON.GENERIC_ERROR' }))
      return
    }
    const {
      partner: { id }
    } = data
    image && onUploadImage(image, id)
    alert.success(intl.formatMessage({ id: 'COMMON.SUCCESS' }))
    reset()
  }

  async function onUploadImage(file, id) {
    const { error } = await uploadPartnerImage({
      token,
      partnerId: id,
      file
    })
    if (error) {
      alert.error(intl.formatMessage({ id: 'COMMON.UPLOAD_IMAGE_ERROR' }))
      return
    }
    setImage(null)
  }

  useEffect(() => {
    document.title = 'Control Room - Nuovo Partner'
  }, [])

  if (!canWrite) {
    let pathname = '/'
    if (location && location.pathname) {
      pathname = location.pathname.split('/')
      pathname.pop()
      pathname = pathname.join('/')
    }
    return <Navigate push={false} to={{ pathname }} />
  }
  return (
    <>
      <div className="flex items-center">
        <Button
          icon={ArrowLeftIcon}
          className="lightblue-btn rounded-circle mr-4"
          onClick={() => history(-1)}
        />
        <PageTitle>
          {intl.formatMessage({ id: 'CREATE_PARTNER.TITLE' })}
        </PageTitle>
      </div>
      <div className="card mb-5 mb-xl-10">
        <form onSubmit={handleSubmit(onSubmit)} className="form">
          <div className="card-body pt-3">
            <div className="row mb-6">
              <label className="col-lg-4 col-form-label required fw-bold fs-6">
                {intl.formatMessage({ id: 'COMMON.NAME' })}
              </label>

              <div className="col-lg-8 fv-row">
                <input
                  className="mt-1 form-control form-control-lg form-control-solid"
                  type="text"
                  {...register('name', {
                    required: intl.formatMessage({ id: 'COMMON.REQUIRED' }),
                    maxLength: {
                      value: 100,
                      message: intl.formatMessage({ id: 'COMMON.MAX_LENGTH' })
                    }
                  })}
                />
                {errors.name && errors.name.message && (
                  <span className="text-xs text-red-400 mt-4">
                    {errors.name.message}
                  </span>
                )}
              </div>
            </div>
            <div className="row mb-6">
              <label className="col-lg-4 col-form-label required fw-bold fs-6">
                {intl.formatMessage({ id: 'COMMON.IMAGE' })}
              </label>

              <div className="col-lg-8 fv-row">
                <UploadImage onImageSelected={file => setImage(file)} />
              </div>
            </div>
            <div className="row mb-6">
              <label className="col-lg-4 col-form-label required fw-bold fs-6">
                {intl.formatMessage({ id: 'COMMON.ACTIVE' })}
              </label>

              <div className="col-lg-8 fv-row">
                <select
                  className="mt-1 form-select form-select-lg form-select-solid"
                  {...register('status', {
                    required: intl.formatMessage({ id: 'COMMON.REQUIRED' })
                  })}>
                  <option value="true">
                    {intl.formatMessage({ id: 'COMMON.YES' })}
                  </option>
                  <option value="false">
                    {intl.formatMessage({ id: 'COMMON.NO' })}
                  </option>
                </select>
                {errors.status && errors.status.message && (
                  <span className="text-xs text-red-400 mt-4">
                    {errors.status.message}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="card-footer d-flex justify-content-end py-6 px-9">
            <button type="submit" className="btn btn-primary">
              {intl.formatMessage({ id: 'COMMON.SAVE' })}
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export default NuovoPartner
